<template>
  <header class="main-header">
    <span class="logo-mini">
      <a href="/"><img src="/static/img/crp-images/Logo_RCP Smart App2.png" alt="Logo" class="img-responsive center-block logo admin-lgg"></a>
    </span>
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>

      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav profile">
          <li class="dropdown user user-menu">
          <md-menu md-size="medium" md-align-trigger>
                <md-button class="md-icon-button" md-menu-trigger>
                  <md-avatar>
                    <img class="user-image" src="/static/img/photo.png" alt="User profile image" />
                  </md-avatar>
                </md-button>

                <md-menu-content class="my-content">
                  <router-link to="/admin/profile">
                    <md-menu-item>
                      <md-icon>account_circle</md-icon>
                      <span class="clr-gray">Profile</span>
                    </md-menu-item>
                  </router-link>
                  <md-menu-item @click="logOut">
                    <md-icon>lock</md-icon>
                    <span class="clr-gray">Logout</span>
                  </md-menu-item>
                </md-menu-content>
              </md-menu>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import MessagesMenu from './MessagesMenu'
import NotificationsMenu from './NotificationsMenu'
import TasksMenu from './TasksMenu'
import UserMenu from './UserMenu'
import Vue from 'vue'

export default {
  name: 'DashHeader',
  components: {
    MessagesMenu,
    NotificationsMenu,
    TasksMenu,
    UserMenu
  },
  props: ['user'],
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  methods: {
    logOut() {
      Vue.auth.destroyToken()
    }
  }
}
</script>
<style scoped>
.my-content{
overflow: unset !important;
justify-content: unset;
cursor: pointer;
background-color: rgba(255, 193, 7, 0.5);
left: 1050px;
}

</style>



// WEBPACK FOOTER //
// DashHeader.vue?004d24f9